import {API} from './Api';

 async function LoginRequest(reqObj){
    return  API.post(`/users/auth`,reqObj);
}

async function VerifyRequest(reqObj){
    return  API.post(`/users/auth/verification`,reqObj);
}

async function SubscribeToTopic(reqObj){
    return  API.post(`/users/current/subscribe-to-topics`,reqObj);
}


export {LoginRequest,VerifyRequest,SubscribeToTopic};